import { Action } from 'redux';
import { User } from '../../clients/aasServerClient.generated';

export enum ActionTypeNames {
    FetchTableUsers = 'Users/FetchTableUsers',
    FetchTableUsersNoSearch = 'Users/FetchTableUsersNoSearch',
    StoreTableUsers = 'Users/StoreTableUsers',

    FetchAllUsers = 'Users/FetchAllUsers',
    StoreAllUsers = 'Users/StoreAllUsers',

    ClearSingleUser = 'Users/ClearSingleUser',
    FetchSingleUser = 'Users/FetchSingleUser',
    NewSingleUser = 'Users/NewSingleUser',
    CopySingleUser = 'Users/CopySingleUser',
    StoreSingleUser = 'Users/StoreSingleUser',
    CreateSingleUser = 'Users/CreateSingleUser',
    SaveSingleUser = 'Users/SaveSingleUser',
    SavedSingleUser = 'Users/SavedSingleUser',

    ActivateUsers = 'Users/ActivateUsers',
    UpdateUsers = 'Users/UpdateUsers',
    DeactivateUsers = 'Users/DeactivateUsers',
    AssignUsersWorkspace = 'Users/AssignUsersWorkspace',
    AssignUsersApplications = 'Users/AssignUsersApplications',
    CreateUserApplicationKey = 'Users/CreateUserApplicationKey',
    GetUserApplicationKeys = 'Users/GetUserApplicationKeys',
    DeleteUserApplicationKey = 'Users/DeleteUserApplicationKey',
    ResetUserApplicationKey = 'Users/ResetUserApplicationKey',
    StoreUserApplicationKey = 'Users/StoreUserApplicationKey',
    AssignUsersGroups = 'Users/AssignUsersGroups',
    DeleteUsers = 'Users/DeleteUsers',
    SendNewUserMail = 'Users/SendNewUsersMail',
    SendResetPasswordMail = 'Users/SendResetPasswordMail',
    SendMigratePasswordMail = 'Users/SendMigratePasswordMail',
    SendMigrateAccountMail = 'Users/SendMigrateAccountMail',
    SendVerifyEmailMail = 'Users/sendVerifyEmailMail',
    SynchronizeUsers = 'Users/SynchronizeUsers',
    
    ImportCSV = 'Users/ImportCSV',
}

export type UsersAction<T extends ActionTypeNames> = Action<T> & {
    userIds: string[];
};

export type FetchTableUsersNoSearchAction = Action<ActionTypeNames.FetchTableUsersNoSearch>;

export type FetchTableUsersAction = Action<ActionTypeNames.FetchTableUsers>;
export type StoreTableUsersAction = Action<ActionTypeNames.StoreTableUsers> & {
    users: User[]
};

export type FetchAllUsersAction = Action<ActionTypeNames.FetchAllUsers>;
export type StoreAllUsersAction = Action<ActionTypeNames.StoreAllUsers> & {
    users: User[]
};

export type FetchSingleUserAction = Action<ActionTypeNames.FetchSingleUser> & {
    id: string;
};
export type NewSingleUserAction = Action<ActionTypeNames.NewSingleUser>;
export type CopySingleUserAction = Action<ActionTypeNames.CopySingleUser> & {
    id: string;
};
export type StoreSingleUserAction = Action<ActionTypeNames.StoreSingleUser> & {
    user: Partial<User>;
};
export type SaveSingleUserAction = Action<ActionTypeNames.SaveSingleUser> & {
    user: Partial<User>;
    workspaceId?: string;
    apps?: Array<{id: string, value: boolean}>;
    groups?: Array<{id: string, value: boolean}>;
    privileges?: Array<{name: string, value: boolean}>;
};
export type CreateSingleUserAction = Action<ActionTypeNames.CreateSingleUser> & {
    user: Partial<User>;
    workspaceId?: string;
    apps?: Array<{id: string, value: boolean}>;
    groups?: Array<{id: string, value: boolean}>;
    mail?: boolean;
    privileges?: Array<{name: string, value: boolean}>;
};
export type ClearSingleUserAction = Action<ActionTypeNames.ClearSingleUser>;
export type SavedSingleUserAction = Action<ActionTypeNames.SavedSingleUser>;

export type ActivateUsersAction = UsersAction<ActionTypeNames.ActivateUsers>;
export type UpdateUsersAction = UsersAction<ActionTypeNames.UpdateUsers>;
export type DeactivateUsersAction = UsersAction<ActionTypeNames.DeactivateUsers>;
export type DeleteUsersAction = UsersAction<ActionTypeNames.DeleteUsers>;
export type SendNewUserMailAction = UsersAction<ActionTypeNames.SendNewUserMail>;
export type SendResetPasswordMailAction = UsersAction<ActionTypeNames.SendResetPasswordMail>;
export type SendMigratePasswordMailAction = UsersAction<ActionTypeNames.SendMigratePasswordMail>;
export type SendMigrateAccountMailAction = UsersAction<ActionTypeNames.SendMigrateAccountMail>;
export type SendVerifyEmailMailAction = UsersAction<ActionTypeNames.SendVerifyEmailMail>
export type SynchronizeUsersAction = UsersAction<ActionTypeNames.SynchronizeUsers>;
export type AssignUsersWorkspaceAction = UsersAction<ActionTypeNames.AssignUsersWorkspace> & {
    workspaceId: string;
};
export type AssignUsersApplicationsAction = UsersAction<ActionTypeNames.AssignUsersApplications> & {
    appIds: string[];
};
export type CreateUsersApplicationKeyAction = UsersAction<ActionTypeNames.CreateUserApplicationKey> & {
    appId: string;
};

export type GetUsersApplicationKeysAction = UsersAction<ActionTypeNames.GetUserApplicationKeys>;

export type DeleteUsersApplicationKeyAction = UsersAction<ActionTypeNames.DeleteUserApplicationKey> & {
    appId: string;
};

export type ResetUserApplicationKeyAction = UsersAction<ActionTypeNames.ResetUserApplicationKey> & {
    appId: string;
    applicationKey: string
};
export type StoreUsersApplicationKeyAction = UsersAction<ActionTypeNames.StoreUserApplicationKey> & {
    appId: string;
    applicationKey: string
};
export type AssignUsersGroupsAction = UsersAction<ActionTypeNames.AssignUsersGroups> & {
    groupIds: string[];
};

export type ImportCSVAction = Action<ActionTypeNames.ImportCSV> & {
    csv: string;
    workspaceId: string;
    emailUsers: boolean;
};
